function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Asset 44");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "aw"
}, React.createElement("path", {
  d: "M12,14C5.48,14,.32,7.58.11,7.31a.48.48,0,0,1,0-.62C.32,6.42,5.48,0,12,0S23.68,6.42,23.89,6.69a.48.48,0,0,1,0,.62C23.68,7.58,18.52,14,12,14ZM1.15,7C2.27,8.27,6.75,13,12,13s9.73-4.73,10.85-6C21.73,5.73,17.25,1,12,1S2.27,5.73,1.15,7ZM12,11.5A4.5,4.5,0,1,1,16.5,7,4.51,4.51,0,0,1,12,11.5Zm0-8A3.5,3.5,0,1,0,15.5,7,3.5,3.5,0,0,0,12,3.5Zm0,6A2.5,2.5,0,0,1,9.5,7a.5.5,0,0,1,1,0A1.5,1.5,0,1,0,12,5.5a.5.5,0,0,1,0-1,2.5,2.5,0,0,1,0,5Z"
})));

var SvgEyeShow = function SvgEyeShow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 14",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeShow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-show.a6f12a7c.svg";
export { ForwardRef as ReactComponent };